<div class="main user-permission-list">
    <div class="title-btn">
        <div class="main-title">
            <h1>User Roles</h1>
            <p>Manage user roles and permissions</p>
        </div>
        <div class="">
            <a routerLink="/user-permission" class="btn-action-primary">
                <i class="fas fa-plus"></i> New Role
            </a>
        </div>
    </div>

    <p-table
        [value]="roles"
        [lazy]="true"
        [loading]="loading"
        responsiveLayout="scroll"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Role Name</th>
                <th>No Of Users</th>
                <th>Actions</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-role>
            <tr>
                <td>{{ role.name }}</td>
                <td>
                    <span class="user-count-badge">{{ role.noUsers }}</span>
                </td>
                <td>
                    <a
                        [routerLink]="['/edit-role', role.id]"
                        pTooltip="Edit Role"
                        tooltipPosition="top"
                        class="action-icon edit-icon"
                    >
                        <i class="far fa-edit"></i>
                    </a>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
